import React from 'react'
import PropTypes from 'prop-types'
import style from './TextButton.less'
import classNames from 'classnames'

const getClassNames = (props) => (
  classNames({
    [style.TextButton]: true,
    [style.hover]: (props.hover),
  })
)
const TextButton = (props) => (
  <a
    className={getClassNames(props)}
    href="#"
    onClick={props.click}
  >
    {props.content}
    {props.svg &&
      <svg viewBox={props.svg.viewBox}>
        <use xlinkHref={`#${props.svg.id}`} />
      </svg>
    }
  </a>
)

TextButton.propTypes = {
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  click: PropTypes.func.isRequired,
  svg: PropTypes.object,
  hover: PropTypes.bool,
}

export default TextButton
